import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const LinkedInIcon: React.FC<CardGradientProps> = ({
  className,
  width = "1.74vw",
  height = "1.74vw",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3885 4.81677H19.9953L14.3003 11.3259L21.0001 20.1832H15.7542L11.6454 14.8113L6.94406 20.1832H4.3357L10.4271 13.2211L4 4.81677H9.37906L13.093 9.72695L17.3885 4.81677ZM16.4736 18.623H17.9181L8.59418 6.29511H7.04414L16.4736 18.623Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LinkedInIcon;
